import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {PAGE_SIZE_DEFAULT, PAGE_SIZE_OPTIONS} from '../../../../constants/paginator';
import {TestCreateDialogComponent} from '../../../components/dialogs/test-create-dialog/test-create-dialog.component';
import {TestsTableComponent} from '../../../components/tables/tests-table/tests-table.component';
import {TestsDataSource} from '../../../data/source/TestsDataSource';
import {TestFilters} from '../../../data/models/filters/test-filters';
import {TestService} from '../../../services/api/test.service';
import {MeService} from '../../../services/api/me.service';
import {TEST_PRIVILEGES} from '../../../../constants/privileges';

@Component({
  selector: 'app-tests',
  templateUrl: './tests-page.component.html',
  styleUrls: ['./tests-page.component.css']
})
export class TestsPageComponent implements OnInit, AfterViewInit {

  readonly PRIVILEGES = TEST_PRIVILEGES;
  readonly pageSizeOptions = PAGE_SIZE_OPTIONS;
  readonly displayedColumns = ['id', 'type', 'name', 'updateDate', 'isActivated'];

  @ViewChild(TestsTableComponent) testsTable!: TestsTableComponent;

  filters: TestFilters = {};
  dataSource: TestsDataSource;
  sort: string[] = ['updateDate', 'desc'];
  pageSize = PAGE_SIZE_DEFAULT;
  pageNumber = 0;

  get queryParams(): object {
    return {
      ...this.filters,
      sort: this.sort,
      size: this.pageSize,
      number: this.pageNumber,
    };
  }

  canAdd = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private meService: MeService,
    private testService: TestService,
  ) {
    this.dataSource = new TestsDataSource(this.testService);
    this.canAdd = this.meService.hasPrivilege(this.PRIVILEGES.CREATE);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (Object.keys(params).length === 0) {
        this.router.navigate([], {
          replaceUrl: true,
          queryParams: this.queryParams,
        });
      } else {
        this.setFilters({
          search: params.search,
          type: params.type,
          isActivated: params.isActivated,
        });
        this.setSort(params.sort);
        this.setPage(params.size, params.number);
        this.loadData();
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.testsTable.sort$.subscribe(sort => {
        this.setSort([sort.active, sort.direction]);
        this.navigate();
      });
      this.testsTable.page$.subscribe(event => {
        this.setPage(event.pageSize, event.pageIndex);
        this.navigate();
      });
    }, 0);
  }

  loadData(): void {
    this.dataSource.loadTests(this.filters,
      this.sort, this.pageSize, this.pageNumber);
  }

  setFilters(filters: TestFilters): void {
    this.filters = filters;
  }

  setSort(sort: string[]): void {
    if (Array.isArray(sort) && sort.length === 2) {
      this.sort = sort;
    }
  }

  setPage(pageSize: number, pageNumber: number): void {
    pageSize = +pageSize;
    pageNumber = +pageNumber;
    if (Number.isInteger(pageSize) && pageSize > 0) {
      this.pageSize = pageSize;
    }
    if (Number.isInteger(pageNumber) && pageNumber >= 0) {
      this.pageNumber = pageNumber;
    }
  }

  onFiltersChange(filters: TestFilters): void {
    if (filters.search === this.filters.search &&
      filters.type === this.filters.type &&
      filters.isActivated === this.filters.isActivated) {
      this.loadData();
    } else {
      this.setFilters(filters);
      this.setPage(this.pageSize, 0);
      this.navigate();
    }
  }

  navigate(): void {
    this.router.navigate([], {
      queryParams: this.queryParams,
    });
  }

  openTestCreateDialog(): void {
    const dialogRef = this.dialog.open(TestCreateDialogComponent, {
      minWidth: '50vw',
      data: {}
    });

    dialogRef.afterClosed().subscribe(test => {
      if (test) {
        this.dataSource.insertTest(test);
      }
    });
  }

}
